import { all, call, takeEvery, fork } from "redux-saga/effects";
import newRequestFunction from "../Utils/newSGF"

import {
  EXPORT_PCA_REPORT,
  PCA_FIND_CM,
  PCA_FETCH_ALL_ACTIVE_SKILLS,
  CREATE_PCA_RECORD,
  GET_ALL_REGISTERED_CM_PCA,
  GET_CM_PCA_BY_ID,
  EDIT_PCA_DATA
} from "../ActionTypes";

import {
  exportPcaReportSuccess,
  exportPcaReportFailure,
  pcaFindCmSuccess,
  pcaFindCmFailure,
  pcaFetchAllActiveSkillsSuccess,
  pcaFetchAllActiveSkillsFailure,
  createPcaRecordSuccess,
  createPcaRecordFailure,
  getAllRegisteredCmSuccessPca,
  getAllRegisteredCmFailurePca,
  getCmPcaByIdSuccess,
  getCmPcaByIdFailure,
  editPcaDataSuccess,
  editPcaDataFailure
} from "../Actions";

import {
  exportPcaReport,
  pcaFindCm,
  pcaGetAllActiveSkills,
  createPCARecord,
  getAllRegisteredCmPca,
  getCmPcaByIdApi,
  editPcaDataApi
} from "../Api";


// Requests
const exportPcaReportRequest = function* () {
  yield call(newRequestFunction, exportPcaReportSuccess, exportPcaReportFailure, exportPcaReport)
}

const pcaFindCmRequest = function* ({ payload }) {
  yield call(newRequestFunction, pcaFindCmSuccess, pcaFindCmFailure, pcaFindCm, payload)
}

const pcaGetAllActiveSkillsRequest = function* ({ payload }) {
  yield call(newRequestFunction, pcaFetchAllActiveSkillsSuccess, pcaFetchAllActiveSkillsFailure, pcaGetAllActiveSkills)
}

const createPCARecordRequest = function* ({ payload }) {
  yield call(newRequestFunction, createPcaRecordSuccess, createPcaRecordFailure, createPCARecord, payload)
}

const getAllRegisteredCmPcaRequest = function* ({ payload }) {
  yield call(newRequestFunction, getAllRegisteredCmSuccessPca, getAllRegisteredCmFailurePca, getAllRegisteredCmPca, payload )
}

const getCmPcaByIdRequest = function* ({ id }) {
  yield call(newRequestFunction, getCmPcaByIdSuccess, getCmPcaByIdFailure, getCmPcaByIdApi, id)
}

const editPcaDataRequest = function* ({ payload }) {
  yield call(newRequestFunction, editPcaDataSuccess, editPcaDataFailure, editPcaDataApi, payload)
}


// Watchers
const exportPcaReportWatcher = function* () {
  yield takeEvery(EXPORT_PCA_REPORT, exportPcaReportRequest)
}

const pcaFindCmWatcher = function* () {
  yield takeEvery(PCA_FIND_CM, pcaFindCmRequest)
}

const pcaGetAllActiveSkillsWatcher = function* () {
  yield takeEvery(PCA_FETCH_ALL_ACTIVE_SKILLS, pcaGetAllActiveSkillsRequest)
}

const createPCARecordWatcher = function* () {
  yield takeEvery(CREATE_PCA_RECORD, createPCARecordRequest)
}

const getAllRegisteredCmPcaWatcher = function* () {
  yield takeEvery(GET_ALL_REGISTERED_CM_PCA, getAllRegisteredCmPcaRequest)
}

const getCmPcaByIdWatcher = function* () {
  yield takeEvery(GET_CM_PCA_BY_ID, getCmPcaByIdRequest)
}

const editPcaDataWatcher = function* () {
  yield takeEvery(EDIT_PCA_DATA, editPcaDataRequest)
}

export default function* rootSaga() {
  yield all([
    fork(exportPcaReportWatcher),
    fork(pcaFindCmWatcher),
    fork(pcaGetAllActiveSkillsWatcher),
    fork(createPCARecordWatcher),
    fork(getAllRegisteredCmPcaWatcher),
    fork(getCmPcaByIdWatcher),
    fork(editPcaDataWatcher),
  ])
}